export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-indent-more-37cb00f79709695cf408e65303ecaa19.svg";